export default __webpack_public_path__ + "static/media/sa.1560eb7e.jpg";